<template>
  <div class="evaluateStyle">
    <div class="pingjia">
      <div class="order-title">
        <p class="keSpan">{{ $tc('lang.Review.Service_Rate') }}</p>
        <a-button type="primary" size="large" @click="gotBack">{{
          $tc('lang.Review.Back')
        }}</a-button>
      </div>
      <div class="pingjia-con">
        <div class="pingjia-con1">
          {{ $tc('lang.Review.Customer_Service_ID')
          }}<span>{{ userServiceId }}</span>
        </div>
        <div class="pingjia-con2">
          <div>
            <span>{{ $tc('lang.Review.Time_keeping') }}</span>
            <a-rate :allowClear="false" v-model="eps.appraisePunctual" />
          </div>
          <div>
            <span>{{ $tc('lang.Review.professional_ethics') }}</span>
            <a-rate :allowClear="false" v-model="eps.appraiseMorality" />
          </div>
          <div>
            <span>{{ $tc('lang.Review.Skill') }}</span>
            <a-rate :allowClear="false" v-model="eps.appraiseMajor" />
          </div>
          <div>
            <span>{{ $tc('lang.Review.Communications') }}</span>
            <a-rate :allowClear="false" v-model="eps.appraiseCooperate" />
          </div>
        </div>
        <div class="pingjia-con3">
          <span>{{ $tc('lang.Review.Comment') }}</span>
          <a-textarea
            style="resize: none; height: 150px;"
            v-model="eps.appraiseRemark"
          />
        </div>
      </div>
    </div>
    <div class="pingjia">
      <div class="order-title">
        <p class="keSpan">{{ $tc('lang.Review.Inspector_Rate') }}</p>
      </div>
      <div class="pingjia-con">
        <div class="pingjia-con1">
          {{ $tc('lang.Review.Inspector_ID')
          }}<span>{{ orderData.personName }}</span>
        </div>
        <div class="pingjia-con2">
          <div>
            <span>{{ $tc('lang.Review.Time_keeping') }}</span>
            <a-rate :allowClear="false" v-model="qcList.appraisePunctual" />
          </div>
          <div>
            <span>{{ $tc('lang.Review.professional_ethics') }}</span>
            <a-rate :allowClear="false" v-model="qcList.appraiseMorality" />
          </div>
          <div>
            <span>{{ $tc('lang.Review.Skill') }}</span>
            <a-rate :allowClear="false" v-model="qcList.appraiseMajor" />
          </div>
          <div>
            <span>{{ $tc('lang.Review.Communications') }}</span>
            <a-rate :allowClear="false" v-model="qcList.appraiseCooperate" />
          </div>
        </div>
        <div class="pingjia-con3">
          <span>{{ $tc('lang.Review.Comment') }}</span>
          <a-textarea
            style="resize: none; height: 150px;"
            v-model="qcList.appraiseRemark"
          />
        </div>
      </div>
    </div>
    <a-button
      type="primary"
      size="large"
      style="
        border: 1px solid #dbdbdb;
        background: #FF8D1A;"
      @click="saveEvaluate"
      >{{ $tc('lang.Review.Save') }}</a-button
    >
  </div>
</template>

<script>
export default {
  name: 'noComponents',
  data() {
    return {
      // 评价人员类型 1客服，2QC
      // 评价类型 2客服，3QC
      // 评价
      eps: {
        id: null,
        appraisePunctual: 5,
        appraiseMajor: 5,
        appraiseMorality: 5,
        appraiseCooperate: 5,
        personContactname: 5,
        appraiseRemark: null,
        appraiseType: 2,
      },
      qcList: {
        id: null,
        appraisePunctual: 5,
        appraiseMajor: 5,
        appraiseMorality: 5,
        appraiseCooperate: 5,
        personContactname: 5,
        appraiseRemark: null,
        appraiseType: 3,
      },
      saveList: [],
      //url 订单信息
      orderData: {},
      // 查询订单的数据
      data: {},
      user: {},
      userServiceId: '',
    };
  },
  created() {
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
    this.orderData = theRequest;
    // this.queryOrder();
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    }
    if (sessionStorage.getItem('userServiceId') !== null) {
      this.userServiceId =
        JSON.parse(sessionStorage.getItem('userServiceId')) || {};
    }
    this.dataList();
  },
  methods: {
    // 返回上一个页面
    gotBack() {
      this.$router.push({
        path: '/noEvaluate',
      });
    },
    // 获取评价信息
    dataList() {
      this.loading = true;
      // const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/person-appraise/getDateByNo', {
          orderId: this.orderData.orderId,
          reportId: this.orderData.reportNo,
        })
        .then(data => {
          if (data != null) {
            const reastData = data.data;
            console.log('======', reastData);
            reastData.map(item => {
              // 客服
              if (item.personType === '2') {
                this.eps = {
                  id: item.id,
                  appraisePunctual: item.appraisePunctual,
                  appraiseMajor: item.appraiseMajor,
                  appraiseMorality: item.appraiseMorality,
                  appraiseCooperate: item.appraiseCooperate,
                  personContactname: item.personContactname,
                  appraiseRemark: item.appraiseRemark,
                  appraiseType: 2,
                };
              }
              // QC
              if (item.personType === '1') {
                this.qcList = {
                  id: item.id,
                  appraisePunctual: item.appraisePunctual,
                  appraiseMajor: item.appraiseMajor,
                  appraiseMorality: item.appraiseMorality,
                  appraiseCooperate: item.appraiseCooperate,
                  personContactname: item.personContactname,
                  appraiseRemark: item.appraiseRemark,
                  appraiseType: 3,
                };
              }
            });
          } else {
            this.qcList = [];
            this.eps = [];
          }
        })
        .catch(() => {
          this.qcList = [];
          this.eps = [];
        });
    },
    // 评价保存
    saveEvaluate() {
      this.loading = true;
      this.saveList = [
        {
          orderId: this.orderData.orderId,
          reportId: this.orderData.reportNo,
          personType: 2,
          personId: this.orderData.personName,
          personContactname: this.userServiceId,
          ...this.eps,
        },
        {
          orderId: this.orderData.orderId,
          reportId: this.orderData.reportNo,
          personType: 1,
          personId: this.orderData.personName,
          personContactname: this.userServiceId,
          ...this.qcList,
        },
      ];
      // FormData 格式
      // const form = new FormData();
      // form.append('data', 1);
      this.$http
        .post('/hzwmj/person-appraise/updateInfo', {
          data: this.saveList,
        })
        .then(data => {
          if (data != null) {
            const reastData = data.data;
            if (reastData === true) {
              this.$message.success('评价成功');
            } else {
              this.$message.error('评价失败');
            }
          } else {
            this.qcList = [];
            this.eps = [];
          }
        })
        .catch(() => {
          this.qcList = [];
          this.eps = [];
        });
    },
  },
};
</script>

<style lang="less">
.evaluateStyle {
  margin-top: 80px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  .order-title {
    .keSpan {
      font-size: 20px;
      font-weight: 600;
    }
    display: flex;
    justify-content: space-between;
    height: 46px;
    align-items: center;
    border-bottom: 1px solid rgb(207, 207, 207);
    button {
      margin: 0 5px;
    }
    p {
      margin-bottom: 0;
      color: #2a82e4;
    }
  }
  .pingjia {
    padding: 30px 56px 0;
    .pingjia-con {
      padding: 20px 0 40px;
      display: flex;
      .pingjia-con1 {
        font-size: 15px;
        width: 15%;
      }
      .pingjia-con2 {
        .ant-rate {
          font-size: 25px;
        }
        font-size: 16px;
        width: 30%;
        span {
          display: inline-block;
          width: 100px;
        }
      }
      .pingjia-con3 {
        display: flex;
        font-size: 16px;
        width: 35%;
        span {
          width: 80px;
        }
      }
    }
  }
}
</style>
